export default {
  production: '65d47ed118264a5dd634e890',
  development: '65d4c51004416716d7ce1759',
};
